//web\src\App.js
import React, { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
//import ChatLauncher from 'components/chat/ChatLauncher';


import store from './store';
import Layouts from './layouts';
import { THEME_CONFIG } from './configs/AppConfig';
import { fetchMe } from 'store/slices/authSlice';

import './lang';

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

const PUBLIC_NO_AUTH_ROUTES = ['/chat-widget'];

function AppContent() {
  const dispatch = useDispatch();
  const location = useLocation();

  const isPublicNoAuthRoute = PUBLIC_NO_AUTH_ROUTES.some((path) =>
    location.pathname.startsWith(path)
  );

  useEffect(() => {
    if (!isPublicNoAuthRoute) {
      dispatch(fetchMe());
    }
  }, [dispatch, isPublicNoAuthRoute]);

  return <Layouts />;
}

function FloatingChat() {
  const location = useLocation();

  const isPublicNoAuthRoute = PUBLIC_NO_AUTH_ROUTES.some((path) =>
    location.pathname.startsWith(path)
  );

  if (isPublicNoAuthRoute) {
    return null;
  }

    //return <ChatLauncher />;
  
}

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter>
          <ThemeSwitcherProvider
            themeMap={themes}
            defaultTheme={THEME_CONFIG.currentTheme}
            insertionPoint="styles-insertion-point"
          >
            <AppContent />
            <FloatingChat />
          </ThemeSwitcherProvider>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;